import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = ["nav", "toggler"]

  lastScrollTop = 0

  connect() {
    this.boundHandleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.boundHandleScroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundHandleScroll)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }

  handleScroll() {
    const current = window.scrollY

    if (current > this.lastScrollTop) {
      this.navTarget.classList.add("scrolling-down")
      this.navTarget.classList.remove("scrolling-up")
    } else {
      this.navTarget.classList.add("scrolling-up")
      this.navTarget.classList.remove("scrolling-down")
    }

    this.lastScrollTop = current <= 0 ? 0 : current

    if (current > 0) {
      this.navTarget.classList.add("scrolled")
      this.navTarget.classList.remove("at-top")
    } else {
      this.navTarget.classList.remove("scrolled")
      this.navTarget.classList.add("at-top")
    }
  }
}
